export default "__VITE_ASSET__BCVdSWox__"